export default __webpack_public_path__ + "static/media/camp-extra-bg.60563806.png";